import Core               from '@/core/Core';
import TradeMark          from '@/domains/TradeMarks/TradeMark';
import TradeMarksDAO      from '@/domains/TradeMarks/TradeMarksDAO';
import ContextMenuItem    from '@/lib/components/VContextMenu/ContextMenuItem';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';
import CharacteristicUnit from "@/domains/CharacteristicUnits/CharacteristicUnit";


class TradeMarksService {

  static async get(id: number): Promise<TradeMark | null> {
    const list = await this.getList({ pattern: undefined });
    return list.find(tm => tm.id === id) ?? null;
  }

  static async getListPaginated(
    params?: Parameters<typeof TradeMarksDAO.getList>[0] & {
      pagination?: RpcDataPagination;
      sort?: RpcDataSort;
    }
  ): Promise<{ data: TradeMark[]; pagination: RpcDataPagination }> {
    const { pagination, sort, ...filters } = params ?? {};
    const response = await TradeMarksDAO.getList(filters, pagination, sort);

    return {
      data:       Core.utils.hydrateArray(response.data, TradeMark.fromServer),
      pagination: response.meta.pagination,
    };
  }

  static async getList(params?: Parameters<typeof TradeMarksDAO.getList>[0]): Promise<TradeMark[]> {
    return (await this.getListPaginated(params)).data;
  }

  static async update(tradeMark: TradeMark): Promise<boolean> {
    const response = await TradeMarksDAO.update(tradeMark);

    if (response.ok) {
      Core.showNotification.success('Торговая марка обновлена');
    }

    return response.ok;
  }

  /**
   * Открыть карточку торговой марки.
   * Промис резолвится по закрытию карточки.
   * Создания нет — марка всегда передаётся объектом из реестра.
   */
  static showCard(tradeMark: TradeMark): Promise<boolean> {
    return Core.dialogs.TradeMarkCard.showAsPromise({ tradeMark });
  }

  // ============================================================
  // Контекстное меню
  // ============================================================

  /**
   * Пункты контекстного меню торговой марки для грида реестра и карточки.
   * Передаётся в VDataGridV2 / VDialogV3 пропом :context-menu.
   *
   * Только «Открыть» — у домена нет создания и удаления (создание неявное,
   * удаления нет), редактирование идёт через карточку.
   */
  static get contextMenu(): ContextMenuItem[] {
    return [
      new ContextMenuItem(
        'Открыть',
        'open_in_new',
        (tradeMark: TradeMark) => { return this.showCard(tradeMark); },
      ),
    ];
  }
}

export default TradeMarksService;
